import { isDevelopmentMode, methods, sendRequest } from "../base";

export const getBankAccounts = () => {
  return sendRequest(isDevelopmentMode() ? "/accounts/bank-accounts" : "");
};

export const widthdrawalRequest = (amount, bankAccount) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/wallets/withdrawal-request"
      : "/payment/settlement/",
    methods.POST,
    { amount: amount, bank_account: bankAccount }
  );
};

export const sendTransactionRequest = (invoice_key) => {
  const BaseUrl = isDevelopmentMode()
    ? process.env.REACT_APP_BASE_WEB_URL
    : "https://talaeshow.com";
  return sendRequest(
    isDevelopmentMode() ? "/payments/transactions" : "/payment/settlement/",
    methods.POST,
    {
      client_redirect_url: `${BaseUrl}/callback`,
      invoice_key: invoice_key,
    }
  );
};

export const updateBankAccount = (id, is_default = true) => {
  return sendRequest(
    isDevelopmentMode() ? `/accounts/bank-accounts/${id}` : "/payment/pay/",
    methods.PATCH,
    { default: is_default }
  );
};

export const depositRequest = (amount, bankAccount) => {
  return sendRequest(
    isDevelopmentMode() ? "/payments/invoices" : "/payment/pay/",
    methods.POST,
    { amount: amount, bank_account: bankAccount }
  );
};

export const getTransactionsHistory = (page, data_type = null) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/wallets/transactions?page=" +
          page +
          (!isNaN(data_type) && data_type !== null
            ? "&data_type=" + data_type
            : "")
      : "/users/bank-info/"
  );
};

export const addBankAccount = (account) => {
  return sendRequest(
    isDevelopmentMode() ? "/accounts/bank-accounts" : "/users/bank-info/",
    methods.POST,
    isDevelopmentMode() ? { card_number: account } : { bank_card: account }
  );
};
